import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  ModeEdit,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import AssetModal from "./AssetModal";
import { useDispatch, useSelector } from "react-redux";
import { setLocale } from "yup";
import axios from "axios";
import { encode } from "../../../Component/JWT/Formatt";
import { isSystemAccess } from "../../../ConfigInfo/Info";
// import CreateAssetCategory from "./AssetCategoryModal";

const Assets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);
  const isSystem = useSelector((state) => isSystemAccess(state.auth.loginInfo));
console.log(actionsAllow)
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  useEffect(() => {
    getData();
    dispatch({ type: "assetEditData", payload: { edit: false, data: {} } });
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["assets"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "locationresult");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "assets");
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });
  };

  const handleButtonNew = () => {
    // setMode("Create");
    navigate("/asset/create?mode=Create");
    // setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const getQrCode = (downloadType = "pdf") => {  // Default to PDF if no argument
    setIsLoading(true);
    const downloadLink = downloadType === "qr" 
      ? masterAPI["assets"].downloadAllQrcodes 
      : masterAPI["assets"].downloadAllQrcodesPdf;
  
    axiosPrivate
      .get(downloadLink, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
  
        // Set default filename based on download type
        let fileName = downloadType === "qr" 
          ? `Site_QR_Codes.zip` 
          : `Site_QR_Codes.pdf`;
  
        // Override with filename from headers if available
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (fileNameMatch?.[1]) {
            fileName = fileNameMatch[1];
          }
        }
  
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error downloading QR codes:", error);
        setIsLoading(false);
        // Optional: Add error state handling here
      });
  };

  const handleEdit = (data) => {
    // setEditData(data);
    // setMode("Edit");
    // setCreate(true);
    // localStorage.setItem("editData",JSON.stringify(data))
    dispatch({ type: "assetEditData", payload: { edit: true, data: data } });
    navigate("/asset/create");
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["assets"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete assets");
  //     });
  // };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["assets"].enable;
    const disableLink = masterAPI["assets"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enableAsset");
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disableAsset");
        });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
            // icon={<RadioButtonUncheckedOutlined />}
            // checkedIcon={<CheckCircle />}
            />
          </Box>
        );
      },
    },

    {
      Header: "Asset  Code",
      accessor: "code",
      // disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Link
            to={`/assets/assetDetails?id=${encode(cell.row.original.id)}`}
            style={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "Asset  Name",
      accessor: "assetName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Parent Asset Name",
      accessor: "parentAssetName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Asset Status",
      accessor: "statusName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Asset Type Name",
      accessor: "assetTypeName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Location Name",
      accessor: "locationName",
      Cell: ({ cell }) => cell.value || "--",
    },
    ...(isSystem
      ? [
          {
            Header: "System Name",
            accessor: "systemName",
            Cell: ({ cell }) => cell.value || "--",
          },
        ]
      : []),
    {
      Header: "Criticality Name",
      accessor: "criticalityName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Priority Name",
      accessor: "priorityName",
      Cell: ({ cell }) => cell.value || "--",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit
                    ? color.masterEditDelButtonColor
                    : "default",
                }}
              />
            </IconButton>
            {/* <IconButton disabled={!actionsAllow.delete}>
              <DeleteOutline
              // disabled={!actionsAllow.delete}
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
                  
                }}
              />
            </IconButton> */}
            <Switch
              disabled={!actionsAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["assets"].title}
        </Typography>
      </Box>


      <TableContainer
        columns={columns}
        data={data}
        qrShow={true}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
        getQrCode={getQrCode}
      />

      {/* <Dialog
        open={create}
        onClose={handleCreateClose}
        children={
          <AssetModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      /> */}
    </>
  );
};

export default Assets;
